import React from "react";

import { css } from "@emotion/react";

import Container from "../Container";
import Message from "../Message";

const CalculatorInactiveText = ({ children }) => {
    const containerStyles = css`
        margin-bottom: -40px !important;
    `;

    return (
        <Container css={containerStyles}>
            <Message header="Hinweis">{children}</Message>
        </Container>
    );
};

export default CalculatorInactiveText;
